import { render } from "./ViewBatches.vue?vue&type=template&id=936a7e46&scoped=true"
import script from "./ViewBatches.vue?vue&type=script&lang=js"
export * from "./ViewBatches.vue?vue&type=script&lang=js"

import "./ViewBatches.vue?vue&type=style&index=0&id=936a7e46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-936a7e46"]])

export default __exports__